<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 id="header-title" class="mb-0"><i class="fa fa-fw fa-check-square mr-2" />Aksesoris</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Nama">
                        <b-form-input id="filter-name" v-model="filter.name" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Jenis">
                        <div id="filter-kind">
                            <multiselect v-model="filter.kind"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                :options="optKind"
                            />
                        </div>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button id="search-button" variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <b-button id="download-button" class="ml-2 btn-dark" @click="downloadMasterAccessory()">
                            <i class="fa fa-download mr-2" />Download
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button id="add-button" variant="success" @click="$bvModal.show('m-create')">
                            <i class="fa fa-plus mr-2" />Aksesoris Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table id="accessory-table" bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data aksesoris.
                </template>
                <template v-slot:cell(action)="row">
                    <b-button id="edit-button" size="sm" variant="warning" v-b-tooltip.hover.top title="Edit" @click="prepareEdit(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Tambah Aksesoris Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group id="create-name-group" label="Nama Aksesoris">
            <b-input id="create-name-input" v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group id="create-kind-group" label="Jenis Barang">
            <multiselect id="create-kind-select" v-model="input.kind"
                label="name"
                track-by="id"
                :internal-search="true"
                deselect-label=""
                select-label=""
                :options="optKind"
            />
            </b-form-group>
            <div class="mt-4 text-right">
            <b-button id="create-save-button" variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
            </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Edit Aksesoris" no-close-on-backdrop no-close-on-esc hide-footer>
            Mengubah aksesoris <strong id="edit-item-name">{{ activeItem.name }}</strong> ({{ activeItem.kind }})
            <b-form-group id="edit-name-group" label="Nama Aksesoris" class="mt-4">
            <b-input id="edit-name-input" v-model="edit.name" maxlength="100" />
            </b-form-group>
            <div class="mt-4 text-right">
            <b-button id="edit-save-button" variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
            </b-button>
            </div>
        </b-modal>
        <b-modal id="m-download" title="Master Aksesoris" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div id="download-status-preparing" v-if="status == 0">
            Menyiapkan file Excel, mohon menunggu...
            </div>
            <div id="download-status-failed" v-else-if="status == -1">
            Gagal menyiapkan file Excel.
            </div>
            <div id="download-status-ready" v-else>
            File Excel sudah siap. Tekan tombol dibawah ini untuk download file Excel.
            <div class="mt-2">
                <a id="download-link" :href="$BASE_FILE_PATH + path" download>
                <b-button id="download-button" variant="primary">
                    <i class="fa fa-download mr-2" />Download Master Aksesoris
                </b-button>
                </a>
            </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                name: "",
                kind: null
            },

            input: {
                name: "",
                kind: null
            },

            edit: {
                name: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "name", label: "Nama Aksesoris", sortable: true },
                { key: "kind", label: "Jenis Barang", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],

            status: 0,

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getMasterKind = this.$axios.get("master/kinds").then(res => {
                this.optKind = res.data.data
            })

            Promise.all([getItems, getMasterKind]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        confirmCreate() {

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.input.kind == null) {
                return this.$helper.toastError(this, "Jenis barang tidak boleh kosong!")
            }

            let isConfirmed = confirm("Simpan aksesoris baru ini?")
            if(!isConfirmed) return

            let payload = {
                name: this.input.name,
                kind: this.input.kind.id
            }

            this.isSubmitting = true
            this.$axios.post("master/accessory", payload).then(res => {

                this.$helper.toastSuccess(this, "Aksesoris baru berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.input.name = ""
                this.input.kind = null
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        prepareEdit(item) {
            this.activeItem = item
            this.edit.name = item.name
            this.$bvModal.show("m-edit")
        },

        confirmEdit() {

            if(this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            let isConfirmed = confirm("Simpan perubahan aksesoris ini?")
            if(!isConfirmed) return

            let payload = {
                name: this.edit.name
            }

            this.isSubmitting = true
            this.$axios.post("master/accessory/" + this.activeItem.id, payload).then(res => {

                this.$helper.toastSuccess(this, "Aksesoris berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.activeItem.name = res.data.data.name
                this.edit.name = ""

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if(this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("master/accessory" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listAksesorisFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        downloadMasterAccessory() {

            this.$bvModal.show("m-download")
            this.status = 0

            this.$axios.post("master/accessory/download-excel-master", this.filter).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
            .catch(error => {
                this.status = -1
                this.$helper.parseError(this, error)
            })
        },

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listAksesorisFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listAksesorisFilter"))
        }
        this.init()
    }
}
</script>
